import { useEffect, useRef, type FC } from 'react';
import { usePostHog } from '@posthog/react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Keeps PostHog person identity in sync with Firebase auth.
 * @see https://posthog.com/docs/libraries/react
 */
const PostHogAuthSync: FC = () => {
  const posthog = usePostHog();
  const { currentUser, loading: authLoading } = useAuth();
  const hadAuthenticatedPostHogUser = useRef(false);

  useEffect(() => {
    if (!posthog) {
      return;
    }

    if (currentUser?.uid) {
      posthog.identify(currentUser.uid, {
        email: currentUser.email ?? undefined,
        name: currentUser.displayName ?? undefined,
      });
      hadAuthenticatedPostHogUser.current = true;
      return;
    }

    if (!authLoading && hadAuthenticatedPostHogUser.current) {
      posthog.reset();
      hadAuthenticatedPostHogUser.current = false;
    }
  }, [authLoading, currentUser, posthog]);

  return null;
};

export default PostHogAuthSync;
